import zappy from "@zappy-ride/library.react.components";

import { SetSelector } from "./SetSelector";
export * from "./SetSelector";

zappy.FactoryInstance.registerComponent(SetSelector);
